import { useEffect } from 'react';

interface StructuredDataProps {
  /** Unique id for the script tag to avoid duplicates */
  id: string;
  /** JSON-LD data object */
  data: Record<string, unknown>;
}

/**
 * Injects a JSON-LD structured data script into <head>.
 * Follows the same pattern as FAQSection.tsx.
 */
export function StructuredData({ id, data }: StructuredDataProps) {
  useEffect(() => {
    const scriptId = `ld-json-${id}`;
    document.getElementById(scriptId)?.remove();

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      document.getElementById(scriptId)?.remove();
    };
  }, [id, data]);

  return null;
}
